import { connectAPI } from "./api"
import { ReceiveJSON, ReceiveNothing } from "./api/base"

const baseUrl = "contracts"

const ReceiveErrorMessage: Api.Receiver = {
    accept: "application/json",
    handler: (response: Response) => {
        if (!response.ok) {
            throw response
        }
    },
}

export const collectContracts = (
    validate: boolean,
): Promise<Contracts.Contract[]> =>
    connectAPI.getJSON(`${baseUrl}?validate=${validate}`)

export const enableContract = (id: string, enabled: boolean): Promise<void> =>
    connectAPI.postJSON(`${baseUrl}/${id}/enable`, enabled, ReceiveErrorMessage)

export const getContractDetails = (id: string): Promise<Contracts.Contract> =>
    connectAPI.getJSON(`${baseUrl}/${id}?withcontent=true`)

export const validateContract = (id: string): Promise<Contracts.ReportData> =>
    connectAPI.getJSON(`${baseUrl}/${id}/validate`)

export const repairContract = (id: string): Promise<Contracts.ReportData> =>
    connectAPI.postVoid(`${baseUrl}/${id}/repair`, ReceiveJSON)

export const getContractsConfiguration =
    (): Promise<Contracts.GlobalSettings> =>
        connectAPI.getJSON(`${baseUrl}/configuration`)

export const setContractsConfiguration = (
    settings: Contracts.GlobalSettings,
): Promise<void> =>
    connectAPI.postJSON(`${baseUrl}/configuration`, settings, ReceiveNothing)
